import React from 'react';
import block from 'bem-cn';
import PT from 'prop-types';

import './AgentItem.scss';
import { rankImages, rankImagesByPosition } from '../../../data';

const b = block('agent-item-mobile');

const AgentItem = ({ item, position, iconByPosition = false }) => {
  const img = iconByPosition ? rankImagesByPosition[position] : rankImages[item.rank];

  return (
    <div className={b()}>
      <div
        className={b('td', {
          divider: true,
        })}>
        {img && <img className={b('rank-img')} src={img} alt={item.rank} />}
        <span>{position}</span>
      </div>
      <div
        className={b('td', {
          divider: true,
        })}>
        <span>{item.username}</span>
      </div>
      <div className={b('td')}>
        <span>{Number(item.points).toFixed(2)}</span>
      </div>
    </div>
  );
};

AgentItem.PropTypes = {
  item: PT.shape({
    id: PT.number.isRequired,
    points: PT.number.isRequired,
    username: PT.string.isRequired,
    rank: PT.string.isRequired,
  }).isRequired,
  position: PT.number.isRequired,
  iconByPosition: PT.bool,
};

export default AgentItem;
